// In miliseconds
export const TIMERS: { [key: string]: number } = {
  otpResend: 130_000,
};
